<template>
    <div class="activity-individual">
        <div class="d-flex justify-content-between item-align-center cur-pointer" @click="showForm">
            <div class="left">
                <span class="date" v-if="activity.is_date_unknown">Unknown Date</span>
                <span class="date" v-else>{{ formatDate(activity.date_added) }}</span>
                <span>{{ activity.source }}</span>
            </div>
            <div class="right" v-if="activity.discount_status != 'Paid'">
                <span class="status" v-if="activity.discount_status == 'Free Loyalty'">F</span>
                <span class="status orange" v-else>C</span>
            </div>
        </div>
        <button :class="[showEditForm ? 'block' : ''] + ' ' + position + ' edit-discount-activity'" @click="showForm" v-if="!view_only"></button>
        <div v-if="showEditForm" :class="'edit-activity ' + position">
            <div class="wrap-div">
                <div class="d-flex align-items-end">
                    <div class="first">
                        <h4>{{ activityName }}</h4>
                        <span class="source-title" v-if="activity.is_date_unknown">Unknown Date</span>
                        <span class="source-title" v-else>{{ formatDate(activity.date_added) }}</span>
                    </div>
                    <div>
                        <span class="source-title">{{ activity.source }}</span>
                    </div>
                </div>
                <div class="d-flex activity-status with-border-top">
                    <span class="source-title">Edit Status</span>
                    <ul>
                        <li>
                            <label class="radio-label" :for="genUniqueId('paid')">
                                <input type="radio" :name="genUniqueId('activity-status[]')" :checked="activity.discount_status == 'Paid'" :id="genUniqueId('paid')" @click="setStatus('Paid')" /> 
                                <span>Paid</span>
                            </label>
                        </li>
                        <li>
                            <label class="radio-label" :for="genUniqueId('free-loyalty')">
                                <input type="radio" :name="genUniqueId('activity-status[]')" :checked="activity.discount_status == 'Free Loyalty'" :id="genUniqueId('free-loyalty')" @click="setStatus('Free Loyalty')" /> 
                                <span class="with-icon">Free Loyalty <i>F</i></span>
                            </label>
                        </li>
                        <li>
                            <label class="radio-label" :for="genUniqueId('free-wtf')">
                                <input type="radio" :name="genUniqueId('activity-status[]')" :checked="activity.discount_status == 'Free WTF'" :id="genUniqueId('free-wtf')" @click="setStatus('Free WTF')" /> 
                                <span class="with-icon">Concession&nbsp;<i class="orange">C</i></span>
                            </label>
                        </li>
                    </ul>
                </div>
                <div v-if="activity.source != 'Registered'" class="with-border-top">
                    <a href="javascript:void(0);" @click="deleteActivity" class="delete-activity">delete this activity...</a>
                </div>
                <div class="d-flex with-border-top">
                    <button class="nfc-cta mt-00" :disabled="isDisabled" @click="updateActivity" >Save</button>
                    <button class="nfc-cta cancel margin-left mt-00" @click="hideForm">Cancel</button>
                </div>
                <div class="staff-details">
                    <p>
                        <strong>Created: </strong>
                        <br>
                        <span v-text="`${formatDate(activity.created_at, true)}  ${activity.registered_staff.username} / ${activity.registered_staff.firstname} ${activity.registered_staff.lastname}`"></span>
                    </p>
                    
                    <p>
                        <strong>Last modified: </strong>
                        <span v-text="`${formatDate(activity.updated_at, true)}  ${activity.updated_staff.username} / ${activity.updated_staff.firstname} ${activity.updated_staff.lastname}`"></span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {mapActions, mapState} from 'vuex';

    export default {
        props: ['activity', 'position', 'view_only'],
        data() {
            return {
                activityStatus: "",
                showEditForm: false,
                isDisabled: true
            }
        },
        computed: {
            activityName() {
                switch(this.activity.activity) {
                    case "bj":
                        return "Bungy";
                    break;
                    case "sj":
                        return "Skyjump";
                    break;
                    case "sw":
                        return "Skywalk";
                    break;
                    case "tc":
                        return "Tower Climb";
                    break;
                }
            }
        },
        methods: {
            ...mapActions(['updateDiscountActivity', 'deleteDiscountActivity', 'setPopupOpenValue']),
            formatDate(date, withTime = false) {
                if(withTime) {
                    return moment(date, 'YYYY-MM-DD hh:mm:ss').format('YYYY MMM DD hh:mm');
                }

                return moment(date, 'YYYY-MM-DD hh:mm:ss').format('YYYY MMM DD');
            },
            genUniqueId(string) {
                return this.activity.activity + "_" + string;
            },
            setStatus(string) {
                this.isDisabled = false;
                this.activityStatus = string;
                return;
            },
            showForm() {
                if(!this.view_only) {
                    this.showEditForm = !this.showEditForm;
                    this.setPopupOpenValue(this.showEditForm);
                }
                return;
            },
            hideForm() {
                this.showEditForm = false;
                this.setPopupOpenValue(false);
            },
            async updateActivity() {
                this.isDisabled = true;
                await this.updateDiscountActivity({
                    activity: this.activity,
                    status: this.activityStatus
                });
                this.showEditForm = false;
                this.setPopupOpenValue(false);
            },
            setActivityStatus() {
                this.isDisabled = true;
                this.activityStatus = this.activity.discount_status;
            },
            async deleteActivity() {
                if(confirm("Are you sure you want to delete this session?")) {
                    await this.deleteDiscountActivity(this.activity);
                    this.showEditForm = false;
                    this.setPopupOpenValue(false);
                }
            }
        },
        async mounted() {
            await this.setActivityStatus();
        },
    }
</script>